import {gql} from '@apollo/client'

export const GET_SHIPPING_PACKAGE_NAME_AVAILABLE = gql`
  query GetBrandNameAvailable($id: UUID, $name: String) {
    shippingPackageNameAvailable(pShippingPackageId: $id, pName: $name)
  }
`

export const GET_SHIPPING_PACKAGES = gql`
  query GetShippingPackages($offset: Int!, $pageSize: Int!) {
    shippingPackages(first: $pageSize, offset: $offset, filter: {deletedAt: {isNull: true}}) {
      nodes {
        id
        name
        dimension {
          height
          length
          width
          units
        }
        weight {
          value
          units
        }
      }
      totalCount
    }
  }
`

export const GET_ALL_SHIPPING_PACKAGES = gql`
  query GetShippingPackages {
    shippingPackages(filter: {deletedAt: {isNull: true}}) {
      nodes {
        id
        name
        dimension {
          height
          length
          width
          units
        }
        weight {
          value
          units
        }
      }
    }
  }
`
export const GET_SHIPPING_PACKAGES_LIST = gql`
  query GetShippingPackages($offset: Int!, $pageSize: Int!, $orderBy: [ShippingPackagesOrderBy!]) {
    shippingPackages(
      first: $pageSize
      offset: $offset
      orderBy: $orderBy
      filter: {deletedAt: {isNull: true}}
    ) {
      nodes {
        id
        name
        dimension {
          height
          length
          width
          units
        }
        weight {
          value
          units
        }
      }
      totalCount
    }
  }
`
export const GET_SHIPPING_PACKAGE = gql`
  query GetShippingPackage($id: UUID!) {
    shippingPackage(id: $id) {
      name
      dimension {
        height
        length
        units
        width
      }
      weight {
        units
        value
      }
    }
  }
`

export const CREATE_SHIPPING_PACKAGES = gql`
  mutation CreateShippingPackages($shippingPackage: ShippingPackageInput!) {
    createShippingPackage(input: {shippingPackage: $shippingPackage}) {
      clientMutationId
    }
  }
`

export const UPDATE_SHIPPING_PACKAGES = gql`
  mutation UpdateShippingPackages($shippingPackage: UpdateShippingPackageInput!) {
    updateShippingPackage(input: $shippingPackage) {
      clientMutationId
    }
  }
`
export const DELETE_SHIPPING_PACKAGE = gql`
  mutation DeleteShippingPackage($id: UUID!) {
    deleteShippingPackage(input: {id: $id}) {
      clientMutationId
    }
  }
`

export const GET_SHIPPING_PACKAGES_WITHOUT_OFFSET = gql`
  query GetShippingPackages {
    shippingPackages(filter: {deletedAt: {isNull: true}}) {
      nodes {
        id
        name
        dimension {
          height
          length
          width
          units
        }
        weight {
          value
          units
        }
      }
      totalCount
    }
  }
`
